import { combineReducers } from "redux";

import adminReducer from "./admin/reducer";

const reducers = combineReducers({
  adminReducer
});

export default reducers;
